import { render, staticRenderFns } from "./BasicDetailsSection.vue?vue&type=template&id=68b10c45&scoped=true&"
import script from "./BasicDetailsSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./BasicDetailsSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BasicDetailsSection.vue?vue&type=style&index=0&id=68b10c45&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b10c45",
  null
  
)

export default component.exports